import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Guards
import { PeticionCoordenadasGuard } from '../app/Home/PeticionCoordenadas/peticionCoordenadas-guard.service';
import { ContrasenaOlvidadaGuard } from '../app/Home/ContrasenaOlvidada/contrasenaOlvidada-guard.service';

// Componentes
import { ErrorComponent } from './Common/Components/Error/error.component';

const appRoutes: Routes = [
    { 
        path: '', 
        loadChildren: './Home/AltaUsuarios/altaUsuarios.module#AltaUsuariosModule' //./Home/home.module#HomeModule
    },    
    { path: 'Error/:desc', component: ErrorComponent },
    { path: 'Home',  loadChildren: './Home/AltaUsuarios/altaUsuarios.module#AltaUsuariosModule'},   
    { path: 'AltaUsuarios/:system',  loadChildren: './Home/AltaUsuarios/altaUsuarios.module#AltaUsuariosModule'},   
    { path: 'AltaUsuarios',  loadChildren: './Home/AltaUsuarios/altaUsuarios.module#AltaUsuariosModule'},   
    { path: 'PeticionCoordenadas/:hmac',  loadChildren: './Home/PeticionCoordenadas/peticionCoordenadas.module#PeticionCoordenadasModule', canActivate: [ PeticionCoordenadasGuard ]},
    { path: 'InformacionProteccionDatos',  
      loadChildren: './Home/InformacionProteccionDatos/informacionProteccionDatos.module#InformacionProteccionDatosModule'},
    { path: 'LoginPortal',  
      loadChildren: './Home/LoginPortal/LoginPortal.module#LoginPortalModule'},
    { path: 'ContrasenaOlvidada/:hmac',  
      loadChildren: './Home/ContrasenaOlvidada/contrasenaOlvidada.module#ContrasenaOlvidadaModule', canActivate: [ ContrasenaOlvidadaGuard ]},
    { path: 'UrlCaducada',  loadChildren: './Home/UrlCaducada/urlCaducada.module#UrlCaducadaModule'},
    { path: 'PoliticaContrasena',  loadChildren: './Home/PoliticaContrasena/politicaContrasena.module#PoliticaContrasenaModule'},
    { path: 'CentroContacto',  loadChildren: './Home/CentroContacto/centroContacto.module#CentroContactoModule'},
    { path: 'InfoRegistroCompleto',  loadChildren: './Home/InfoRegistroCompleto/infoRegistroCompleto.module#InfoRegistroCompletoModule'},
    { path: 'InfoReactivacionCompleta',  loadChildren: './Home/InfoReactivacionCompleta/infoReactivacionCompleta.module#InfoReactivacionCompletaModule'},
    { path: 'CambioContrasenaCompleto',  loadChildren: './Home/CambioContrasenaCompleto/cambioContrasenaCompleto.module#CambioContrasenaCompletoModule'},
    { path: 'PeticionEmailCambioContrasena',  loadChildren: './Home/PeticionEmailCambioContrasena/peticionEmailCambioContrasena.module#PeticionEmailCambioContrasenaModule'}
   
];

@NgModule({
    
    imports: [
        RouterModule.forRoot(
            appRoutes
        )
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
